import {
  FOOTER_PAGE_ID,
  MAIN_PAGE_ID,
  SERVICE_PAGE_ID,
} from 'core-components/sitebuilder/layout/constants/sitePages'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { IUser } from 'core-components/sitebuilder/models/IUser'

export const isAvailablePage = (
  sitePages: ISitePage[],
  user: IUser,
  page: ISitePage | undefined
): boolean => {
  const isAdmin = user.roleIds.includes('SuperAdmin')

  if (isAdmin) {
    return true
  }

  if (!page) {
    return false
  }

  const userRoles = new Set(user.roleIds || [])

  let availableRoles: Set<string> | null = null

  let current: ISitePage | undefined = page
  let previous: ISitePage | undefined = undefined
  while (current) {
    const roles = new Set(current.roleIds || [])

    if (current.rolesMode === 'Included') {
      const hasOneOrMoreAvailableRoles = Array.from(roles).some((role) => userRoles.has(role))
      const accessForAll = roles.size === 0
      if (!hasOneOrMoreAvailableRoles && !accessForAll) {
        return false
      }
      availableRoles = roles
    } else if (current.rolesMode === 'Excluded') {
      if (availableRoles === null) {
        availableRoles = new Set(userRoles)
      }
      roles.forEach((role) => availableRoles!.delete(role))

      const hasOneOrMoreAvailableRoles = Array.from(availableRoles).some((role) =>
        userRoles.has(role)
      )
      const accessForAll = roles.size === 0
      if (!hasOneOrMoreAvailableRoles && !accessForAll) {
        return false
      }
    }

    previous = current
    current = current.parent ? sitePages.find((p) => p.id === current?.parent) : undefined
  }

  if (previous) {
    // we need to stop on general pages
    return [MAIN_PAGE_ID, SERVICE_PAGE_ID, FOOTER_PAGE_ID].includes(previous.id)
  }

  return true
}
